<div class="ap-cookie-consent">
    <div class="ap-cookie-consent__container" [ngClass]="{ canvas: layout !== 'small', 'canvas-small': layout === 'small' }">
        <h2 class="ap-margin-top-0">{{ 'cookie.consent.intro.header' | apContent }}</h2>
        <p>
            <ap-content key="cookie.consent.intro.text"></ap-content>
        </p>
        <ap-button type="button" data-bb="accept" [ariaLabel]="'cookie.consent.accept.aria' | apContent" (onClick)="acceptCookies(true)">
            {{ 'cookie.consent.accept.label' | apContent }}
        </ap-button>
        <ap-button
            type="button"
            data-bb="decline"
            [ariaLabel]="'cookie.consent.decline.aria' | apContent"
            variant="secondary"
            (onClick)="acceptCookies(false)"
        >
            {{ 'cookie.consent.decline.label' | apContent }}
        </ap-button>
    </div>
</div>
